/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';
import type { LaunchStatusHy } from './LaunchStatusHy';
import {
    LaunchStatusHyFromJSON,
    LaunchStatusHyFromJSONTyped,
    LaunchStatusHyToJSON,
    LaunchStatusHyToJSONTyped,
} from './LaunchStatusHy';

/**
 * 
 * @export
 * @interface CopyPricePreviewItem
 */
export interface CopyPricePreviewItem {
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewItem
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof CopyPricePreviewItem
     */
    productName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CopyPricePreviewItem
     */
    theme: string | null;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewItem
     */
    priceUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof CopyPricePreviewItem
     */
    priceUnitName: string | null;
    /**
     * 
     * @type {LaunchStatusHy}
     * @memberof CopyPricePreviewItem
     */
    launchStatus: LaunchStatusHy;
    /**
     * 
     * @type {PriceStatus}
     * @memberof CopyPricePreviewItem
     */
    pricingStatus: PriceStatus;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewItem
     */
    rrp: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewItem
     */
    retailMargin: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPricePreviewItem
     */
    lp: number;
    /**
     * 
     * @type {boolean}
     * @memberof CopyPricePreviewItem
     */
    isSource: boolean;
}



/**
 * Check if a given object implements the CopyPricePreviewItem interface.
 */
export function instanceOfCopyPricePreviewItem(value: object): value is CopyPricePreviewItem {
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('theme' in value) || value['theme'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('priceUnitName' in value) || value['priceUnitName'] === undefined) return false;
    if (!('launchStatus' in value) || value['launchStatus'] === undefined) return false;
    if (!('pricingStatus' in value) || value['pricingStatus'] === undefined) return false;
    if (!('rrp' in value) || value['rrp'] === undefined) return false;
    if (!('retailMargin' in value) || value['retailMargin'] === undefined) return false;
    if (!('lp' in value) || value['lp'] === undefined) return false;
    if (!('isSource' in value) || value['isSource'] === undefined) return false;
    return true;
}

export function CopyPricePreviewItemFromJSON(json: any): CopyPricePreviewItem {
    return CopyPricePreviewItemFromJSONTyped(json, false);
}

export function CopyPricePreviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyPricePreviewItem {
    if (json == null) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'productName': json['productName'],
        'theme': json['theme'],
        'priceUnitId': json['priceUnitId'],
        'priceUnitName': json['priceUnitName'],
        'launchStatus': LaunchStatusHyFromJSON(json['launchStatus']),
        'pricingStatus': PriceStatusFromJSON(json['pricingStatus']),
        'rrp': json['rrp'],
        'retailMargin': json['retailMargin'],
        'lp': json['lp'],
        'isSource': json['isSource'],
    };
}

export function CopyPricePreviewItemToJSON(json: any): CopyPricePreviewItem {
    return CopyPricePreviewItemToJSONTyped(json, false);
}

export function CopyPricePreviewItemToJSONTyped(value?: CopyPricePreviewItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productId': value['productId'],
        'productName': value['productName'],
        'theme': value['theme'],
        'priceUnitId': value['priceUnitId'],
        'priceUnitName': value['priceUnitName'],
        'launchStatus': LaunchStatusHyToJSON(value['launchStatus']),
        'pricingStatus': PriceStatusToJSON(value['pricingStatus']),
        'rrp': value['rrp'],
        'retailMargin': value['retailMargin'],
        'lp': value['lp'],
        'isSource': value['isSource'],
    };
}

